// extracted by mini-css-extract-plugin
export default {"icon":"player_icon__dhIrE","player":"player_player__-yTs3"};